import camelize from 'camelcase-keys-deep';

export default class ProcessEquipment {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }
}
